

import {Card, CardTitle, CardMedia} from 'material-ui';

import React from 'react';
import { Dialog } from 'material-ui';
import _ from 'lodash';
import { Player } from 'video-react';
import "../../../../node_modules/video-react/dist/video-react.css"; // import css
<link rel="stylesheet" href="/css/video-react.css" />






// These are inline styles
// You can pass styles as objects using this convention


const styles = {
  cardMedia: {
    maxHeight: 394,
    overflow: 'hidden'
  },
  card: {
    cursor: 'pointer',
    height: 150,
    overflow: 'hidden'
  },
  bgImage: {
    width: '100%'
  }
};




class MovieCardComponent extends React.Component {
  constructor(props) {
    super(props);
    // Track if the mouse hovering over the movie card
    this.state = {
      isMouseOver: false, 
      movieid: null,
      showModal : false, 
      moviedetails : null
    };

    
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this); 
  }


  handleOpenModal () {
    this.setState({ showModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showModal: false });
  }


  setMovieIDNull(){
    this.setState({ movieid: null});
  }

  render() {
    const {movie} = this.props;
    

    // The CardTitle.subtitle won't render if it's null
    const subtitle = this.state.isMouseOver ? "by joobster" : null;


  return (
    <div>
    <Card
      style={styles.card}
      onMouseOver={() => this.setState({isMouseOver: true})}
      onMouseLeave={() => this.setState({isMouseOver: false})}
      onClick= {() => this.handleOpenModal()}
    >
      <CardMedia
        style={styles.cardMedia}
        overlay={
          <CardTitle
            title={movie.title} 
            subtitle={subtitle} 
          />
        }
      >
        <img style={styles.bgImage} src={movie.video.videoThumbLow} />
      </CardMedia>
    </Card>
        

      <Dialog
        autoScrollBodyContent={true}
        title={null}
        modal={false}
        open={this.state.showModal}
        onRequestClose={ this.handleCloseModal }        
      >

        <Player playsInline poster={this.props.movie.video.videoThumbLow} src={this.props.movie.video.videoLow} />            
      

    </Dialog>


     
    </div>
  );

  }
}


export default MovieCardComponent;



// WEBPACK FOOTER //
// ./src/modules/movie-browser/movie-card/movie-card.component.js